"use client"

import RoughEmeraldsHeader from "./rough-emeralds-header"
import RoughEmeraldsGrid from "./rough-emeralds-grid"

export default function RoughEmeraldsPage() {
  return (
    <div className="min-h-screen bg-neutral-50">
      <RoughEmeraldsHeader />
      <RoughEmeraldsGrid />
    </div>
  )
}
